import { NotifyType } from 'app/projects/shared/src/lib/enums/notify-type.enum';
import { RelevantExecution } from 'app/library/program-item/models/relevant-execution.model';
import { ProgramArchiveOption } from '../enums/program-archive-option.enum';
import { Module } from '../models/module.model';

export class UpdateModuleStatus {
    static readonly type = '[Module] UpdateModuleStatus';

    constructor(
        public payload: {
            module: Module | RelevantExecution;
            notify?: NotifyType;
            archive_option?: ProgramArchiveOption;
        }
    ) {}
}
